function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsxs as l, jsx as r } from "react/jsx-runtime";
import { useIsInverseVariant as n } from "../../theme-variant-context.js";
import { vars as c } from "../../skins/skin-contract.css-mistica.js";
const h = (_param)=>{
    var { color: s , size: o = 24  } = _param, e = _object_without_properties(_param, [
        "color",
        "size"
    ]);
    const i = n(), t = s !== null && s !== void 0 ? s : i ? c.colors.inverse : c.colors.neutralHigh;
    return /* @__PURE__ */ l("svg", _object_spread_props(_object_spread({
        width: o,
        height: o,
        viewBox: "0 0 24 24",
        role: "presentation"
    }, e), {
        children: [
            /* @__PURE__ */ r("path", {
                fill: t,
                d: "M17.481 18.07a.724.724 0 01-.732.715.724.724 0 01-.732-.715c0-.396.328-.716.732-.716.404 0 .732.32.732.716z"
            }),
            /* @__PURE__ */ r("path", {
                fill: t,
                d: "M9.08 2h6.574c1.827 0 3.287 1.427 3.29 3.215v13.57c0 1.788-1.463 3.215-3.286 3.215H9.084c-1.828 0-3.287-1.431-3.287-3.215v-4.642c0-.212.143-.356.363-.356.217 0 .364.14.364.356v3.57h8.034c.217 0 .364.145.364.357s-.143.355-.364.355H6.524v.356c0 1.392 1.129 2.5 2.556 2.5h6.574c1.422 0 2.555-1.104 2.555-2.5V6.282H6.524v5.366h6.39c.217 0 .364.14.364.356 0 .212-.143.356-.364.356H2.473l1.574 1.535a.338.338 0 010 .5.402.402 0 01-.258.108.402.402 0 01-.257-.108L1.05 12l2.482-2.391a.356.356 0 01.51 0 .338.338 0 010 .5l-1.57 1.535h3.32v-6.43C5.793 3.428 7.257 2 9.08 2zM6.524 5.215v.356H18.21v-.356c0-1.392-1.128-2.5-2.555-2.5H9.08c-1.423 0-2.556 1.104-2.556 2.5z"
            })
        ]
    }));
}, g = h;
export { g as default };
